import React, { useEffect, useState } from 'react';
import { ethers, BigNumber } from 'ethers';
import { Box, Button, Flex, Text, Image, Center, SimpleGrid , useToast } from '@chakra-ui/react';
import NFT from './NFT.json';
import { HeaderX } from './HeaderX';
import { RoundX } from './RoundX';
import { RoundY } from './RoundY';
import { NumberMintOpen } from './NumberMintOpen';
import './App.css'
import './new.css'
// import image1 from './assets/image/123.png';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { useAccount ,useContractReads, usePrepareContractWrite, useContractWrite, useDisconnect, useWaitForTransaction } from 'wagmi';

const { MerkleTree } = require('merkletreejs');
const keccak256 = require('keccak256');
window.Buffer = window.Buffer || require("buffer").Buffer;

const MainMint = ({ accounts, setAccounts}) => {

    //* START FIRST SETTING ----------------------------------------------- //
    const networkId = 5;
    const NFTAddress = "0xEBE8B3F32b4B2171e4b8Cfca6AbF7E738c2CDc63";
    const collectionSupply = 5555; //แตกต่างจาก collectionSize ตรงที่ ใน CollectionSize เอาไว้จำกัดการ mint ในแต่ระรอบ
    const maxWhitelistCanMint = 5555;
    const teamSupply = 100;
    const maxPerPublicX = 4 ;
    const maxPerWhitelistX = 4 ;
    const maxPerAllowlistX = 4 ;
    // แก้ ABI ที่ไฟล์ NFT.json
    // แก้ Whitelist Address ด้านล่าง
    // เอา Root อัพเดตบน SmartContract

    const Pbseed = 9871231;

    const WhitelistAddressA = ["0x44ca4bd15a09f8d7cd7b52ca1ab8c6d54ef20e61","0x7A7e906E4aEDC53b5532CeAE08095134e67a7EF7","0x542A7F54569685f357Da5B8a6106Fe3DDcDA996b"]

    const AllowlistAddressA = [
        "0x5B38Da6a701c568545dCfcB03FcB875f56beddC4",
        "0x5A641E5FB72A2FD9137312E7694D42996D689D99",
        "0xDCAB482177A592E424D1C8318A464FC922E8DE40",
        "0x6E21D37E07A6F7E53C7ACE372CEC63D4AE4B6BD0",
        "0x6E21D37E07A6F7E53C7ACE372CEC63D4AE4B6BD7",
        "0xaf4129C7500CC9B6a4c12D5f736e8B90379dDF76",
        "0xCa3357b2840156FEE99a302dEEbf9DAD2E894C19",
        "0x75963B63D551Fc3723F3Ca40bc43c45201b35f33",
        "0x542A7F54569685f357Da5B8a6106Fe3DDcDA996b",
      ];

    //* END FIRST SETTING  ----------------------------------------------- //

    const [JsonX, setJsonX] = useState({
        mintPrice : 1,
        totalSupply : 0,
        collectionSize : 0,
        maxWhitelistMinted : 0,
    })

    const [mintAmount, setMintAmount] = useState(1);
    const isConnectedx = Boolean(accounts[0]);
    
    const [errorText, setErrorText] = useState("");
    
    const [json, setJson] = useState({})

    const [maxPerRound, setMaxPerRound] = useState()

    const [ProofX, setProofX] = useState()
    const [Verify, setVerify] = useState()

    const [maxCanMint, setMaxCanMint] = useState()

    const [currentMintPrice, setCurrentMintPrice] = useState()

    const toast = useToast()

    const whitelistLeft = JsonX.maxWhitelistCanMint - JsonX.totalSupply ;
    const totalLeft =  JsonX.collectionSize - JsonX.totalSupply ;

    //* START RAINBOW KIT ------------------------------------//


    const {address, isConnected, isDisconnected} = useAccount()

    const { disconnect } = useDisconnect()

    const wagmigotchiContract = {
        address: NFTAddress,
        abi: NFT.abi,
      }
      

      const { data, isError, isLoading, isSuccess } = useContractReads({
        contracts: [
          {
            ...wagmigotchiContract,
            functionName: 'mintPrice',

            // 0
          },
          {
            ...wagmigotchiContract,
            functionName: 'totalSupply',
            
            // 1
          },
          {
            ...wagmigotchiContract,
            functionName: 'numberMinted',
            args : [address]

            // 2
          },
          {
            ...wagmigotchiContract,
            functionName: 'mintPhase',

             // 3
          },
          {
            ...wagmigotchiContract,
            functionName: 'numberMinted',
            args: [address],
            // 4
          },
          {
            ...wagmigotchiContract,
            functionName: '_addressDetail',
            args: [address],
            // 5
          }
        ],
        allowFailure: false,
        watch: true,
        onSuccess(data) {

            //* START ตัดคำ

            const firstAddressA = address.slice(0,6)
            const lastAddressA = address.slice(37,-1)

            //* END

            
                    //* START MerkleTree

                    const MintPhaseA = data[3] ; 

                    if (MintPhaseA == 1 ) {
                        
                    let whitelistAddresses = WhitelistAddressA ;

                      const leavesWL = whitelistAddresses.map((x) => keccak256(x))
                      const treeWL = new MerkleTree(leavesWL, keccak256, { sortPairs: true })

                      const rootWL = treeWL.getRoot()

                      const leafWL = keccak256(address);
                      // const leaf = keccak256("0x5B38Da6a701c568545dCfcB03FcB875f56beddC4")

                      const buf2hexWL = x => '0x' + x.toString('hex')

                      const proofWL = treeWL.getProof(leafWL).map(x => buf2hexWL(x.data))
                    
                      setProofX(proofWL)
                    
                      const WLverify = treeWL.verify(proofWL, leafWL, rootWL)

                      setVerify(WLverify)

                    }
                      // =======================
                    else if (MintPhaseA == 3) {

                      let allowlistAddresses = AllowlistAddressA ;

                      const leavesAL = allowlistAddresses.map((x) => keccak256(x))

                      const treeAL = new MerkleTree(leavesAL, keccak256, { sortPairs: true })

                      const rootAL = treeAL.getRoot()

                      const leafAL = keccak256(address);
                      // const leaf = keccak256("0x5B38Da6a701c568545dCfcB03FcB875f56beddC4")

                      const buf2hexAL = x => '0x' + x.toString('hex')

                      const proofAL = treeAL.getProof(leafAL).map(x => buf2hexAL(x.data))

                      setProofX(proofAL)

                      const ALverify = treeAL.verify(proofAL, leafAL, rootAL)

                      setVerify(ALverify)

                        // =======================

                    } else {

                    }


                    //   console.log("Whitelist : ", WLverify)
                    //   console.log("Allowlist : ", ALverify)

                    //* END MerkleTree

                    //* START MINT PHASE
                    let thisRound ;
                    let myMinted ;
                    let roundCanMint ;

                    let ThisRoundIs = parseInt(MintPhaseA)

                    if (ThisRoundIs == 0) {
                        setMaxPerRound(maxPerWhitelistX)
                        thisRound = "Whitelist Round";
                    } else if (ThisRoundIs == 1) {
                        setMaxPerRound(maxPerWhitelistX)
                        thisRound = "Whitelist Round";

                        const leftCheck = collectionSupply - Number(data[1]);
                        const maxCanMintX = maxPerWhitelistX - Number(data[5][0]);

                        myMinted = Number(data[5][0]) ;
                        roundCanMint = Number(maxPerWhitelistX) ;

                        if(leftCheck < maxCanMintX) {
                            setMaxCanMint(leftCheck)
                        } else {
                            setMaxCanMint(maxCanMintX)
                        }

                    } else if (ThisRoundIs == 2) {
                        // setMaxPerRound(maxPerAllowlistX)
                        // thisRound = "Allowlist Round";
                    } else if (ThisRoundIs == 3) {
                        setMaxPerRound(maxPerAllowlistX)
                        thisRound = "Allowlist Round";

                        const leftCheck = collectionSupply - Number(data[1]);
                        const maxCanMintX = maxPerAllowlistX - Number(data[5][1]);

                        myMinted = Number(data[5][1]) ;
                        roundCanMint = Number(maxPerAllowlistX) ;

                        if(leftCheck < maxCanMintX) {
                            setMaxCanMint(leftCheck)
                        } else {
                            setMaxCanMint(maxCanMintX)
                        }

                    } else if (ThisRoundIs == 4) {
                        setMaxPerRound(maxPerPublicX)
                        thisRound = "Public Round";
                    } else if (ThisRoundIs == 5) {
                        setMaxPerRound(maxPerPublicX)
                        thisRound = "Public Round";

                        myMinted = Number(data[5][2]) ;
                        roundCanMint = Number(maxPerPublicX) ;

                        const leftCheck = collectionSupply - Number(data[1]);
                        const maxCanMintX = maxPerPublicX - Number(data[5][2]);

                        if(leftCheck < maxCanMintX) {
                            setMaxCanMint(leftCheck)
                        } else {
                            setMaxCanMint(maxCanMintX)
                        }


                    } else if (ThisRoundIs == 6) {
                        setMaxPerRound(maxPerWhitelistX)
                        thisRound = "Mint has ended";
                    } else {
                        setMaxPerRound(maxPerWhitelistX)
                        thisRound = "";
                    }

                    //* END MINT PHASE

            //* START SET JSONX
            setJsonX({
                mintPrice : ethers.utils.formatEther(data[0].toString())
                ,totalSupply : Number(data[1])
                ,numberMinted : Number(data[2])
                ,mintPhase : parseInt(MintPhaseA)
                ,FAddress : firstAddressA
                ,LAddress : lastAddressA
                ,collectionSize : collectionSupply,
                maxWhitelistCanMint : maxWhitelistCanMint,
                maxPerPublic : maxPerPublicX,
                maxPerWhitelist : maxPerWhitelistX,
                maxPerAllowlist : maxPerAllowlistX,
                numberMinted : Number(data[4]),
                addressDetailWL : Number(data[5][0]),
                addressDetailAL : Number(data[5][1]),
                addressDetailPB : Number(data[5][2]),
                thisRound : thisRound,
                myMinted : myMinted,
                roundCanMint : roundCanMint,
                
            })
        }
      })

    //* START MINT ZONE RAINBOW KIT //-----------

    const NewwMintPrice = JsonX.mintPrice * BigNumber.from(mintAmount)
    const NewestMintPrice = NewwMintPrice.toFixed(10)

    // //* START WHITELIST MINT ZONE RAINBOW KIT //-----------

    const { config:WLmintConfig , error:WLerror } = usePrepareContractWrite({
        address: NFTAddress,
        abi: NFT.abi,
        functionName: 'mintWhiteList',
        args: [BigNumber.from(mintAmount)],
        overrides: {
            from: address,
            value: ethers.utils.parseEther((NewestMintPrice).toString()),
        },
    })

    const { data:WLData, isLoading:WLisLoading, isSuccess:WLisSuccess, write:WLWrite } = useContractWrite({
        ...WLmintConfig,
        onSuccess(data) {
            // console.log('Success', data)
            toast({
                title: 'Minting',
                status: 'success',
                position: 'top-right',
                duration: 9000,
                isClosable: true,
            })
        },
        onError(WLerror) {
            // console.log('Error', WLerror)
            toast({
                title: 'Mint Fail',
                status: 'error',
                position: 'top-right',
                duration: 9000,
                isClosable: true,
            })
        },
    })

    // //* START ALLOWLIST MINT ZONE RAINBOW KIT //-----------

    const { config:ALmintConfig , error:ALerror } = usePrepareContractWrite({
        address: NFTAddress,
        abi: NFT.abi,
        functionName: 'mintAllowList',
        args: [BigNumber.from(mintAmount),ProofX],
        overrides: {
            from: address,
            value: ethers.utils.parseEther((NewestMintPrice).toString()),
        },
    })

    const { data:ALData, isLoading:ALisLoading, isSuccess:ALisSuccess, write:ALWrite } = useContractWrite({
        ...ALmintConfig,
        onSuccess(data) {
            // console.log('Success', data)
            toast({
                title: 'Minting',
                status: 'success',
                position: 'top-right',
                duration: 9000,
                isClosable: true,
            })
        },
        onError(ALerror) {
            // console.log('Error', ALerror)
            toast({
                title: 'Mint Fail',
                status: 'error',
                position: 'top-right',
                duration: 9000,
                isClosable: true,
            })
        },
    })

    // //* START PUBLIC MINT ZONE RAINBOW KIT //-----------

    const { config:PBmintConfig , error:PBerror } = usePrepareContractWrite({
        address: NFTAddress,
        abi: NFT.abi,
        functionName: 'publicMint',
        args: [BigNumber.from(mintAmount)],
        overrides: {
            from: address,
            value: ethers.utils.parseEther((NewestMintPrice).toString()),
        },
    })

    const { data:PBData, isLoading:PBisLoading, isSuccess:PBisSuccess, write:PBWrite } = useContractWrite({
        ...PBmintConfig,
        onSuccess(data) {
            // console.log('Success', data)
            toast({
                title: 'Minting',
                status: 'success',
                position: 'top-right',
                duration: 9000,
                isClosable: true,
            })
        },
        onError(PBerror) {
            // console.log('Error', PBerror)
            toast({
                title: 'Mint Fail',
                status: 'error',
                position: 'top-right',
                duration: 9000,
                isClosable: true,
            })
        },
    })
    

    // const WLWrite = 1;
    // const ALWrite = 1;
    // const PBWrite = 1;
    

     //* END MINT ZONE RAINBOW KIT //-----------


      //* END RAINBOW KIT ------------------------------------//

    function getErrorText(a) {
        let b = a.split('execution reverted: ');
        if (b.length == 1) {
            setErrorText(b[0])
        } else if (b.length == 2) {
            setErrorText(b[1])
        } else {
            setErrorText(a)
        }
    }

    async function handleMint() {
            try {

                 if (JsonX.mintPhase == 1) {
                    // Whitelist round
                    
                    WLWrite?.()

                }
                else if (JsonX.mintPhase == 3) {
                    // Allowlist round
                    
                    ALWrite?.()

                } else if (JsonX.mintPhase == 5) {
                    // Public Round
                    
                    PBWrite?.()

                }
                else {
                    
                    console.log("Mint is close")
                    
                }

            } catch (err) {
                console.log("error: ", err.error.data.message)
                getErrorText(err.error.data.message)
            }
    }


    const handleDecrement = () => {

        if (mintAmount <= 1) return;
        setMintAmount(mintAmount - 1);

    }

    const handleIncrement = () => {

        if (mintAmount >= maxCanMint) return;
        setMintAmount(mintAmount + 1);

    }


    useEffect(() => {

        // document.title = 'French Fries Festival - Free Mint NFT';
        // document.description = 'Wish You Were Here.';

    },[])
    

        return (

            <div>
                <Flex justify="center" align="center" >
                    <Box width="480px">
                        
                        <div
                                className="mintZone1"
                        >

                        {isConnected ? (
                            <>
                                <div
                                    className="mintZone"
                                
                                >
                                    <Box
                                        marginBottom="20px"
                                        align="right"
                                    >
                                        <Button
                                            colorScheme='yellow'
                                            onClick={() => disconnect()}
                                        >
                                        Logout
                                        </Button>
                                    </Box>
                                    <center>
                                        {/* <Image
                                            borderRadius='20px'
                                            boxSize='150px'
                                            src={image1}
                                        /> */}
                                    </center>

                                    <Text
                                    marginTop="25px"
                                    fontSize="40px"
                                    letterSpacing="0.8px"
                                    color="black"
                                    
                                    >{JsonX.mintPrice} ETH</Text>

                                     <Text
                                    marginTop="25px"
                                    fontSize="20px"
                                    letterSpacing="0.8px"
                                    color="black"
                                    
                                    >THIS MINT CREATE FOR TEST ONLY</Text>

                                    <Text
                                        marginTop="10px"
                                        fontSize="25px"
                                        letterSpacing="0.8px"
                                        
                                        color="black"
                                    >{JsonX.thisRound}</Text>

                                    { JsonX.mintPhase == 1 ?
                                    <Text
                                        marginTop="0px"
                                        fontSize="16px"
                                        letterSpacing="0.8px"
                                        color="black"
                                    >(There are {totalLeft} NFT left for Whitelist round.)</Text>
                                    : JsonX.mintPhase == 3 || JsonX.mintPhase == 5 ? 
                                    <Text
                                        marginTop="0px"
                                        fontSize="16px"
                                        letterSpacing="0.8px"
                                        color="black"
                                    >(There are {totalLeft} NFT left for {JsonX.thisRound}.)</Text>
                                    :
                                    <></>
                                    }

                                    <Text
                                        marginTop="10px"
                                        fontSize="23px"
                                        letterSpacing="0.8px"
                                        
                                        color="black"
                                    >Total Minted : {JsonX.totalSupply} / {JsonX.collectionSize}</Text>
                                
                                    <Text
                                        marginTop="10px"
                                        fontSize="23px"
                                        letterSpacing="0.8px"
                                        color="black"
                                    >You minted : {JsonX.myMinted} / {JsonX.roundCanMint}</Text>

                                    <NumberMintOpen
                                        HandleDecrement = {handleDecrement}
                                        HandleIncrement = {handleIncrement}
                                        MintAmount = {mintAmount}
                                        HandleMint = {handleMint}
                                        JsonX = {JsonX}
                                        Verify = {Verify}
                                        WLWrite = {WLWrite}
                                        networkId = {networkId}
                                    />

                                    <Text
                                        marginTop="10px"
                                        fontSize="13px"
                                        letterSpacing="0.8px"
                                        
                                        color="black"
                                    >(Your address : {JsonX.FAddress}...{JsonX.LAddress})</Text>


                                    <Text
                                        marginTop="20px"
                                        mb="25px"
                                        fontSize="25px"
                                        letterSpacing="0.8px"
                                        
                                        color="black"
                                    >{errorText}</Text>

                                </div>

                                <HeaderX 

                                />
                                
                                <RoundX 
                                    JsonX = {JsonX}
                                />

                            </>
                            ) : (
                                <>
                                <div className="loginZone"> 
                                    
                                    <center>
                                        {/* <Image
                                            borderRadius='20px'
                                            boxSize='150px'
                                            mb="10px"
                                            src={image1}
                                        /> */}
                                    </center>

                                    <Text
                                        fontSize="28px"
                                        padding="5px 0px"
                                        color="black"
                                        mb="30px"
                                        
                                    >
                                        Connect wallet to mint TEST NFT.
                                    </Text>   

                                    <Text
                                    marginTop="25px"
                                    fontSize="20px"
                                    letterSpacing="0.8px"
                                    color="black"
                                    
                                    >THIS MINT CREATED FOR TEST ONLY</Text>

                                    <Box
                                        className="MintBTN"
                                    >
                                        <ConnectButton 
                              
                                        />   
                                    </Box>
                                    
                                    <Text
                                        marginTop="20px"
                                        fontSize="25px"
                                        color="black"
                                    >{errorText}</Text>
                                
                                </div>

                                <HeaderX />

                                <RoundY
                                    JsonX = {JsonX}
                                />
                            </>
                            
                            )}
                    
                    </div>

                    </Box>
                    
                    
                </Flex>
            </div>
        );
};

export default MainMint;